"use strict";Object.defineProperty(exports, "__esModule", {value: true});
var _uuid = require('shared/services/uuid');
var _message = require('shared/enum/message');




 const MessageTypes = {
  META: "meta",
  TEXT: "text",
  FILE: "file",
  // A team's automatic reply to a patient: an "Auto-reply" bubble.
  AUTO_REPLY: "auto_reply",
  DATE: "date",
  MARKER: "marker",
}; exports.MessageTypes = MessageTypes

 const SenderTypes = {
  PATIENT: "patient",
  USER: "user",
  API_KEY: "api_key",
  NONE: "",
}; exports.SenderTypes = SenderTypes

function getProperSenderKey (keyList) {
  for (let i = 0; i < keyList.length; i++) {
    const key = keyList[i]
    if (key && key !== _uuid.EMPTY_BLUID) {
      return key
    }
  }
}

/* The FileInfo fields read here; rows may carry more (FileKey, LocalMime). */






































































































































const Message = (props) => {
  const {
    Avatar,
    ConversationKey,
    DisplayName,
    FileName,
    FileInfo,
    FileReference,
    MessageKey,
    MessageText,
    MessageType,
    PatientKey,
    APIKeyKey,
    SenderType,
    SentAt,
    TeamKey,
    UserKey,
    SeenBy,
    SameSenderAsNextMessage,
    SameSenderAsPreviousMessage,
    Uploading,
    SendFailed,
    CurrentUserKey,
    Subscribers,
    renderTextMessage,
    renderFileMessage,
    renderMetaMessage,
    renderAutoReplyMessage,
    renderDateMarker,
    highlighted,
    onDelete,
    deleted,
    deliveryStatus,
    ReplyToMessageKey,
    ReplyPreview,
    Mentions,
    onReply,
    onJumpToMessage,
  } = props

  const allSenderKeys = [PatientKey, UserKey, TeamKey, APIKeyKey]
  const senderKey = getProperSenderKey(allSenderKeys)

  const commonMessageProps = {
    senderAvatar: Avatar,
    senderType: SenderType,
    senderName: DisplayName,
    senderKey: senderKey,
    showAvatar: !SameSenderAsNextMessage,
    showName: !SameSenderAsPreviousMessage,
    sentAt: SentAt,
    seenBy: SeenBy,
    currentUserKey: CurrentUserKey,
    subscribers: Subscribers,
    onDelete: onDelete,
    conversationKey: ConversationKey,
    deleted,
    deliveryStatus: deliveryStatus || _message.deliveryStatus.DELIVERED,
    replyToMessageKey: ReplyToMessageKey,
    replyPreview: ReplyPreview,
    onReply,
    onJumpToMessage,
  }

  switch (MessageType) {
    case exports.MessageTypes.TEXT:
      return renderTextMessage({
        text: MessageText,
        mentions: Mentions,
        sendFailed: SendFailed,
        messageKey: MessageKey,
        highlighted: highlighted,
        ...commonMessageProps,
      })
    case exports.MessageTypes.FILE:
      return renderFileMessage({
        messageKey: MessageKey,
        sendFailed: SendFailed,
        fileReference: FileReference,
        fileName: FileName,
        fileSize: FileInfo ? FileInfo.Size : 0,
        filePreview: FileInfo ? FileInfo.PreviewUrl : null,
        fileMime: FileInfo ? FileInfo.Mime : '',
        blurHash: FileInfo ? FileInfo.BlurHash : undefined,
        imageWidth: FileInfo ? FileInfo.ImageWidth : undefined,
        imageHeight: FileInfo ? FileInfo.ImageHeight : undefined,
        thumbnailUrl: FileInfo ? FileInfo.ThumbnailURL : undefined,
        durationMs: FileInfo ? FileInfo.DurationMs : undefined,
        uploading: Uploading,
        highlighted: highlighted,
        ...commonMessageProps,
      })
      /* TODO image file here */
    case exports.MessageTypes.DATE:
      return renderDateMarker({
        text: MessageText,
        messageKey: MessageKey,
        sentAt: SentAt,
      })
    case exports.MessageTypes.AUTO_REPLY:
      if (MessageText && renderAutoReplyMessage) {
        return renderAutoReplyMessage({
          text: MessageText,
          messageKey: MessageKey,
          sentAt: SentAt,
          highlighted: highlighted,
        })
      }
      // falls through: without its renderer it draws as a meta line
    case exports.MessageTypes.META:
    /* default means either old client or bad backend. For now we do our best to degrade
     * into a meta message
     */
    default:
      if (MessageText) {
        return renderMetaMessage({
          text: MessageText,
          messageKey: MessageKey,
          sentAt: SentAt,
          highlighted: highlighted,
        })
      }
      return null
  }
}

exports. default = Message
